import * as XLSX from "xlsx";

export async function parseFaldonXlsx(file) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { cellDates: true });
  const ws = wb.Sheets[wb.SheetNames[0]];

  const get = (addr) => {
    const cell = ws?.[addr];
    const value = cell?.v;
    if (value === undefined || value === null) return "";
    return String(value);
  };

  const header = {
    startDate: get("C2"),
    endDate: get("D2"),
    legalText: get("C3"),
    format: get("C4"),
    campaign: get("C5"),
    campaignName: get("C6"),
  };

  const ref = ws["!ref"] || "A1";
  const rng = XLSX.utils.decode_range(ref);
  const range = { s: { r: 7, c: 0 }, e: { r: rng.e.r, c: rng.e.c } };

  const rowsRaw = XLSX.utils.sheet_to_json(ws, {
    range,
    defval: "",
    raw: false,
  });

  // Handle Excel headers with newlines (visible as either '\n' or unicode ↵, or even CRLF)
  function normalizeHeaderLabel(label) {
    if (typeof label !== "string") return label;
    // Remove extra whitespace including all newlines, CR, LF etc., also replace non-breaking spaces
    return label
      .replace(/[\r\n↵]+/g, " ")         // replace all kinds of newline/arrow chars with a space
      .replace(/\s+/g, " ")              // collapse multiple white spaces to a single space
      .replace(/\u00A0/g, " ")           // replace non-breaking with normal space
      .trim();
  }

  // Map rows to column defs used in DB
  // FALDON => FALDON
  // PRECIO MODAL => precioModal
  // AHORRAS => ahorras
  // CAMPAÑA => nombreCampanaProd
  // CATEGORIA => categoria
  // DESCRIPCION ↵FALDON => descripcionFaldon
  // DRENADO => drenado
  // EAN 13 => ean13
  // FACTORES DE VENTA => factoresDeVenta
  // LEGAL => textoLegal
  // MARCA => marca
  // NOMBRE ↵FALDON => nombreFaldon
  // NOMBRE MECANICA => nombreMecanica
  // PORCENTAJE => porcentaje
  // PPUM => ppum
  // PPUM_MODAL => ppumModal
  // PRECIO F2 => precioF2
  // PRECIO F3 => precioF3
  // PRECIO OFERTA TOTAL X FACTOR => precioOfertaTotalXFactor
  // PRECIO OFERTA UNITARIO => precioOfertaUnitario
  // PRODUCTO => producto
  // TEXTO A => textoA
  // TEXTO B => textoB
  // TEXTO C => textoC
  // TEXTO D => textoD
  // UMV PPUM => umvPpum
  // UNIDAD => unidad
  // __EMPTY => precioOfertaUnitario2
  // __EMPTY_1 => precioOfertaUnitario3
  // __EMPTY_2 => factoresDeVenta2
  // __EMPTY_3 => factoresDeVenta3

  const columnDefs = {
    faldon: "FALDON",
    precioModal: "PRECIO MODAL",
    ahorras: "AHORRAS",
    nombreCampanaProd: "CAMPAÑA",
    categoria: "CATEGORIA",
    descripcionFaldon: "DESCRIPCION FALDON",
    drenado: "DRENADO",
    ean13: "EAN 13",
    factoresDeVenta: "FACTORES DE VENTA",
    legal: "LEGAL",
    marca: "MARCA",
    nombreFaldon: "NOMBRE FALDON",
    nombreMecanica: "NOMBRE MECANICA",
    porcentaje: "PORCENTAJE",
    ppum: "PPUM",
    ppumModal: "PPUM_MODAL",
    precioF2: "PRECIO F2",
    precioF3: "PRECIO F3",
    precioOfertaTotalXFactor: "PRECIO OFERTA TOTAL X FACTOR",
    precioOfertaUnitario: "PRECIO OFERTA UNITARIO",
    producto: "PRODUCTO",
    textoA: "TEXTO A",
    textoB: "TEXTO B",
    textoC: "TEXTO C",
    textoD: "TEXTO D",
    umvPpum: "UMV PPUM",
    unidad: "UNIDAD",
    precioOfertaUnitario2: "__EMPTY",
    precioOfertaUnitario3: "__EMPTY_1",
    factoresDeVenta2: "__EMPTY_2",
    factoresDeVenta3: "__EMPTY_3",
    negocio: "NEGOCIO",
    ppumOferta2: "PPUM_OFERTA2",
    ppumOferta3: "PPUM_OFERTA3",
    futuroViral1: "FUTURO VIRAL 1",
    futuroViral2: "FUTURO VIRAL 2",
    futuroViral3: "FUTURO VIRAL 3",
    futuroViral4: "FUTURO VIRAL 4",
    futuroViral5: "FUTURO VIRAL 5"
  };
  
  // Build reverse lookup once: header label -> canonical key
  const headerToCanonical = Object.fromEntries(
    Object.entries(columnDefs).map(([canonicalKey, headerLabel]) => [normalizeHeaderLabel(headerLabel), canonicalKey])
  );

  // Precompute mapping plan only for headers that actually exist in the data
  const sampleRow = rowsRaw[0] || {};
  const mappingPlan = Object.keys(sampleRow)
    .map((sourceKey) => {
      const normalizedKey = normalizeHeaderLabel(typeof sourceKey === "string" ? sourceKey : "");
      const targetKey = headerToCanonical[normalizedKey];
      return targetKey ? [sourceKey, targetKey] : null;
    })
    .filter(Boolean);

  // Fast mapping with minimal allocations per row
  const rows = new Array(rowsRaw.length);
  for (let i = 0; i < rowsRaw.length; i++) {
    const source = rowsRaw[i];
    const dest = {};
    for (let j = 0; j < mappingPlan.length; j++) {
      const [sourceKey, targetKey] = mappingPlan[j];
      dest[targetKey] = source[sourceKey];
    }
    // Add some header values to the dest object for every row for comparison
    dest.textoLegal = header.legalText;
    dest.formatoImpresion = header.format;
    rows[i] = dest;
  }

  return { fileName: file.name, header, rows };
}


